import React from 'react';
import moment from 'moment';

const NotificationDate = ({ date }) => {
  return (
    <div>
      <span className="gx-text-grey">{moment(date).fromNow()}</span>
    </div>
  );
};

export default NotificationDate;
